import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1200px;
  // margin: 0 auto;
`

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`

export const CardHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CardContent = styled.div`
  padding: 24px;
`

export const ExpansionPanel = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
`

export const ExpansionPanelSummary = styled.div`
  padding: 16px 24px;
  background: #f5f5f5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;

  &:hover {
    background: #eeeeee;
  }
`

export const ExpansionPanelDetails = styled.div`
  padding: 24px;
`

export const HelpText = styled.div`
  background: #f8f9fa;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;

  h3 {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
  }
`

export const AutomationServicesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 20px 0 12px;
`

export const AutomationServiceCard = styled.div`
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
`

export const AutomationServiceCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`
